import { lazy } from "react";
import { RoleGuard } from "../contexts/RoleGuard";
import { AuthGuard } from "../utils/AuthGuard";
import { ScreenLoader } from "../utils/ScreenLoader";

const DeviceTransactionReport = ScreenLoader(
  lazy(() => import("../screens/DeviceTransactionReport")),
);

export const DeviceTransactionReportRoute = () => ({
  path: "device-transaction-report",
  element: (
    <AuthGuard>
      <RoleGuard
        requiredPermission="cashReport"
        requiredActions={["isRead"]}
        isSuperAdmin={true}
      >
        <DeviceTransactionReport />
      </RoleGuard>
    </AuthGuard>
  ),
});
